import { render } from "./Pictures.vue?vue&type=template&id=18abef70"
import script from "./Pictures.vue?vue&type=script&lang=js"
export * from "./Pictures.vue?vue&type=script&lang=js"
script.render = render

export default script